<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap v-if="planIdentity.CurrentPlanMemberEligibility">
      <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
        {{ $t("components.plancreationwizard.include_waiting_period") }}
        <br />
        <span class="minfo">
          {{
            planIdentity.CurrentPlanMemberEligibility.IncludeWaitingPeriod
              ? $t("globals.yes")
              : $t("globals.no")
          }}
        </span>
      </v-col>
      <template
        v-if="planIdentity.CurrentPlanMemberEligibility.IncludeWaitingPeriod"
      >
        <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
          {{ $t("components.plancreationwizard.waiting_period_unit") }}
          <br />
          <span class="minfo">
            {{ planIdentity.CurrentPlanMemberEligibility.WaitingPeriodUnit }}
          </span>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="pt-0 pb-0">
          {{ $t("components.plancreationwizard.waiting_period_unit") }}
          <br />
          <span class="minfo">
            {{ planIdentity.CurrentPlanMemberEligibility.WaitingPeriod }}
          </span>
        </v-col>
      </template>
    </v-layout>
    <v-row v-else>
      {{$t("components.plan_member_eligibility_rules.no_rules_exist")}}
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: ["planIdentity"],
  data() {
    return {};
  },
};
</script>

<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
</style>
